import React from "react";
import "./App.css";
import TopPage from "./pages/Home";
import Projects from "./pages/Projects"
// import Brands from "./pages/Brands";
// import Portfolio from "./pages/Portfolio"
import { 
  Routes,
  Route,
  useLocation, 
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import SingleProject from "./pages/Projects/SingleProject";
import Navbar from "./components/Navbar";
import AboutUs from "./pages/About";

function App() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">

      <div>
      <Navbar />
      </div>
        <Routes location={location} key={location.pathname}>
        <Route path="/" element={<TopPage />} /> 
        <Route path="/projects" element={<Projects />} />
        <Route path="/portfolio/:id" element={<SingleProject />} /> 
        <Route path="/about" element={<AboutUs />} />
        <Route path="*">Page not found</Route>
      </Routes>
    </AnimatePresence>
  );
}

export default App;
